/**
 * 主入口文件
 *
 * 管综寻路原理可视化软件 - 多楼层 + 竖井（V3）
 * 设备机房 → 可走管空间 → 竖井 → 跨层末端 · 三维最短连接路径
 */

// 导入 Three.js
import * as THREE from 'three';

// 导入样式
import './styles/main.css';

// ════════════════════════════════════════════════════════════════════
// App 命名空间 - 导入共享的 App 对象
// ════════════════════════════════════════════════════════════════════
import { App } from './App/App';

// 导入各模块（模块会自动注册到 App 对象上）
import './App/Config';
import './App/Store';
import './App/World';
import './App/Routing';
import './App/Render';
import './App/Layers';
import './App/UI';
import './App/Command';
import './App/IO';
import './App/Selection';
import './App/Interaction';
import './App/boot';

// 将 App 挂载到 window 以便调试
(window as any).App = App;

// ════════════════════════════════════════════════════════════════════
// 启动应用
// ════════════════════════════════════════════════════════════════════
console.log('🏗️ 管综寻路可视化软件 V3 启动中...');
console.log('📦 模块已加载:', Object.keys(App).filter(k => k !== 'boot'));

// 当 DOM 加载完成后启动
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    App.boot();
    console.log('✅ 应用已启动');
  });
} else {
  App.boot();
  console.log('✅ 应用已启动');
}

export default App;
